import { render } from "./casino.vue?vue&type=template&id=2e81fc22&scoped=true"
import script from "./casino.vue?vue&type=script&lang=js"
export * from "./casino.vue?vue&type=script&lang=js"

import "./casino.vue?vue&type=style&index=0&id=2e81fc22&scoped=true&lang=css"

import exportComponent from "/Users/cole/.codex/worktrees/jwt-cookie-expiry/tcd-cube_opr/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e81fc22"]])

export default __exports__